import React, { useEffect, useState, createRef, LegacyRef, useRef } from 'react'
import { IonAvatar, IonBackButton, IonBadge, IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonChip, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonItem, IonItemDivider, IonLabel, IonList, IonListHeader, IonPage, IonRow, IonSegment, IonSegmentButton, IonSpinner, IonText, IonTitle, IonToolbar, isPlatform, useIonViewDidEnter, useIonViewDidLeave } from '@ionic/react'
import Api from "../../services/Api"
import { StepChallengeInterface, StepChallengePersonInterface } from './StepChallenges'
import { useParams } from 'react-router';
import { SafetyPadding } from '../../components/SafetyPadding';
import Pie from './Circle/Circle';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/reducers';
import { arrowForward, map, people, person, reload, trophy } from 'ionicons/icons';
import dayjs from 'dayjs';
import { goToPage } from '../../helpers/app_actions';
import { openSettings } from '../../helpers/step_helper';

interface ParamTypes {
  id: string
}

const ChallengeStatistic = () => {
  const { id } = useParams<ParamTypes>()
  const api = Api.getInstance()
  const today = new Date ().setHours(0,0,0,0)
  const todayFormat = dayjs().format('YYYY-MM-DD')
  const myself = useSelector((state: RootState)=> state.logIn.user.person)
  const [stepData, setStepData] = useState<StepChallengeInterface>({
    id: 0,
    name: '',
    start: '',
    end: '',
    routeName: '',
    routeDistance: 0,
    stepsDone: 0,
    distanceDone: 0,
    persons: []
  })
  const [myStats, setMyStats] = useState({
    enabled: false,
    dailyGoal: 8500,
    stepsPerDay: {} as any,
    today: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  })
  const [score, setScore] = useState<Array<StepChallengePersonInterface>>()
  const [segment, setSegment] = useState<string | undefined>('details')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const ref = createRef<SVGPathElement>()

  const getStepChallenge = () => {
    api.get('pedometer/step_challenge/' + id).then(res => {
      res.json().then(data => {
        if(data.status === 'ok') {
          setStepData(data.challenge)
          if(checkDatePast() === 'Aktiv') {
            api.post('pedometer/sync', {}).then(result => {
              result.json().then(resData => {
                if(resData.status === 'ok') {
                  setMyStats({
                    enabled: resData.enabled,
                    dailyGoal: resData.dailyGoal,
                    stepsPerDay: resData.stepsPerDay,
                    today: resData.stepsPerDay[todayFormat] !== undefined ? resData.stepsPerDay[todayFormat] : [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
                  })
                  myChallengeSteps(data.challenge.start)
                  setLoading(true)
                } else {
                  setLoading(true)
                  setError(true)
                }
              })
            })
          }
        }
      })
    })
  }

  useEffect(() => {
    checkDatePast()
  },[stepData])

  useEffect(() => {
    const timer = setTimeout(() => {
      animateSwedenPath()
    }, 1000)


    return () => clearTimeout(timer)
  }, [loading && !error])

  useEffect(() => {
    sortNum()
  }, [stepData])

  const checkDatePast = () => {
    const challengeEnd = new Date (stepData.end).setHours(0,0,0,0)

    if (challengeEnd < today) {
      return 'Ej aktiv'
    } else {
      return 'Aktiv'
    }
  }

  const daysLeft = () => {
    const challengeEnd = new Date (stepData.end).setHours(0,0,0,0)
    const diffTime = challengeEnd - today
    const diffDays = diffTime / (1000 * 3600 * 24)

    return diffDays
  }

  const percentageToGoal = () => {
    return (stepData.distanceDone / stepData.routeDistance) * 100
  }

  const sortNum = () => {
    const highscore = stepData.persons.sort((a, b) => {
      return b.stepsTotal - a.stepsTotal;
    })

    setScore(highscore)
  }

  const animateSwedenPath = () => {
    const path = document.querySelector('#path1380') as any
    if(path) {
      const length = path.getTotalLength()
      path.style.transition = path.style.WebkitTransition = 'none';
      path.style.strokeDasharray = length;
      path.style.strokeDashoffset = length 
      path.getBoundingClientRect();
      path.style.transition = path.style.WebkitTransition =
        'stroke-dashoffset 2s ease-in-out';
      path.style.strokeDashoffset = ((100 - percentageToGoal()) * length) / 100;;
    }
  }

  const myChallengeSteps = (start: string) => {
    const challengeStart = start
    const now = new Date();
    const stepsInChallenge: Array<{[key:string]: Array<number>}> = []
    for (let d = new Date(challengeStart); d <= now; d.setDate(d.getDate() + 1)) {
      const day = dayjs(new Date(d)).format('YYYY-MM-DD')
      if(myStats.stepsPerDay[day] !== undefined) {
        stepsInChallenge.push({[day]: myStats.stepsPerDay[day]})
      } else {
        stepsInChallenge.push({[day]: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]})
      }
    }

    return stepsInChallenge 
  }

  const averageStepsMonth = () => {
    let averageDay: Array<any> = []
    myChallengeSteps(stepData.start).forEach(day => {
      averageDay.push({[Object.keys(day)[0]]: Object.values(day)[0].reduce((partialSum, a) => partialSum + a, 0)})
    })

    return averageDay
  }

  const averageStepsDay = () => {
    let averageMonthly: Array<any>= []
    myChallengeSteps(stepData.start).forEach(day => {
      averageMonthly.push(Object.values(day)[0].reduce((partialSum, a) => partialSum + a, 0))
    })

    return Math.round((averageMonthly.reduce((partialSum, a) => partialSum + a, 0) / averageMonthly.length) * 10) / 10
  }

  useIonViewDidEnter(() => {
    getStepChallenge()
  })

  useIonViewDidLeave(() => {
    setLoading(false)
    setStepData({
      id: 0,
      name: '',
      start: '',
      end: '',
      routeName: '',
      routeDistance: 0,
      stepsDone: 0,
      distanceDone: 0,
      persons: []
    })
  })

  return (
    <IonPage className="cheap_desktop">
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton/>
          </IonButtons>
          <IonTitle>{api.tr('activity_challenge')}</IonTitle>
          <IonChip 
            slot="end" 
            className="p-2 m-2" 
            color={checkDatePast() === 'Aktiv' ? 'primary' : 'medium'}>
              {checkDatePast() === 'Aktiv' ? <>{api.tr('days_left')} { daysLeft() > 0 ? daysLeft() : null } </> : null}
          </IonChip>
        </IonToolbar>
      </IonHeader>
      { loading ? 
      <IonContent>
        { error ? 
          <>
            <IonGrid>
              <IonRow className="flex justify-center items-center p-2 mt-4">
                <IonText>{api.tr('could_not_load')}</IonText>
              </IonRow>
            </IonGrid>
          </> 
          : 
          <IonGrid>
          <IonSegment 
            value={segment} 
            onIonChange={(e) => {
              setSegment(e.detail.value)
            }}>
            <IonSegmentButton className="m-2" value="details">{api.tr('details')}</IonSegmentButton>
            <IonSegmentButton className="m-2 flex" value="leader">
              <IonLabel className="flex justify-center items-center">
                {api.tr('leaderboard')}
                <IonIcon icon={person} className="ml-2"/>
                {stepData.persons.length}
              </IonLabel>
            </IonSegmentButton>
          </IonSegment>
          {segment === 'details' ? 
          <IonGrid>
            <IonRow className="m-2">
              <IonCardHeader className="fullWidth">
                <IonCardTitle mode="md"  className="color_blue flex justify-between items-center fullWidth">
                  <h1>{stepData.name}</h1>
                  <IonButton size="small" onClick={() => animateSwedenPath()}>
                    <IonIcon icon={reload} />
                  </IonButton>
                </IonCardTitle>              
                <IonCardSubtitle mode="md" className="mt-2">
                  <h3>{stepData.routeName}</h3>
                  {stepData.start} - {stepData.end}
                </IonCardSubtitle>
              </IonCardHeader> 
            </IonRow>
            <IonRow>
              <IonCol size="6" className="p-2 flex items-center justify-center" style={{'height': '35vh'}}>
                <svg 
                  className=""
                  // width={'100px'}
                  height={'100%'}
                  xmlns="http://www.w3.org/2000/svg" 
                  viewBox="0 0 284.22 670.66">
                    <g 
                      id="Layer_2" 
                      data-name="Layer 2">
                      <g id="Layer_1-2" data-name="Layer 1"><g id="layer1">
                      <path 
                        ref={ref}
                        id="path1380" 
                        className="cls-1 path" 
                        stroke="#000" 
                        strokeWidth="2" 
                        fill="whitesmoke"
                        // strokeDasharray="0"
                        // strokeDashoffset="0"
                        d="M46.9,670.16c-21.42-7.35,6.47-6.5-17.73-44.76-3.56-8.37,15.67,8.44,6.58-4.19-9.85-12.12,8.11-1.76,4.18-13-43.31-42.5-12-96.47-31.55-83.25-8.12-1.3-11-35.83-3.69-41.37,6.53-7.31,1.73,18.49,9.61,6,1.59-45.72,17.86-34.81,27.58-72.65-17.09-38.71,4.46-12.83,7.47-41.47C26.11,352.87,22.86,242,70.94,245.15c9.75.83,14.08-10.1,10.19-17.82-6.53-23.55,18.47-45.54,13.26-70.25-1.54-10.79,11.45-12.86,16.67-18.3-5.21-16.46,17.89-28,17.93-43.53-1.49-3.19-7.94-14.31-3.32-17.87,10-3.12,7.53-24,20.08-27.95,17.84,13.81,13.1-9.09,14.12-20.51,6-7,23.09,3.76,32.33,5.29,9.34-11.55-4.78-1.36,4.67-17.48,5-7.09-7.62-14.43-1.51-16.2,53.44,22.89,65,45.33,79,101.33-8.09,38.89,29.58,46.69-6.6,53.57a9.75,9.75,0,0,1-8-2.08c-5.76-4.7-1,4.65-5.14,2.47-9.88-2.34.32,14-9.44,14-7.36.67,6.34,2.32-5.07,6.4a7.35,7.35,0,0,0-4.72,8.53c5.73,12.81-10,16.57-2.53,25.75-1.55,5,12.42,11.62,5.94,16.77-13.68,39.66-55,49-70.89,86.16.64,17.9-16,6-13.87,15.26,17.22,11.15-11.94,28.52-4.21,38.73,1.39,0,1.29,8.25.46,8.19-.46,2.44,5.17,2.27,1.08,7.38-2.74,5.67,2,9.34-.24,15.61.12,2.85,4.07,0,2.61,3.89-1.34,2.13,4,4.9.84,5.88-5.09,4.54,9,1.6,7.82,5.29a2.27,2.27,0,0,0,3.7,2c6.44-2.84,14.85,10.29,17.23,17.76,2.47,6.13,8.93-.42,8.91,4.5,3.53,9.8,10.9,15,1.49,18.85-3.53,3.87-12.88,16.68-16.34,14.53-1.71-2.1-4.14,3.35-2,2.83,18.84-6.22,14.7,9.16,8.83,5.16-9.23-9.73,3.89,5.31-3.9,8.6-7.7-4.24-9.75,22.59-12.3,7.64-.87-9.91-4.93,4-6.23,5.3.22,3.16-3.59,4.09-7.41,4.59-2.19,2.24-10.66,15.75-10.65,20.63,1.78,10.61-7.86,113.09-27.47,104.79-4.92,1.24-37.28-2.34-26.29,5.57,1.75,5-5.1.4-6.68,0-17.5,8.07,3.56,27.81-11,31.81C63.85,663,55.68,670.09,46.9,670.16Z"/></g></g></g></svg>
              </IonCol>
              <IonCol size ="6" className="flex justify-center" style={{'height': '35vh'}}>
                <IonRow>
                  <Pie
                    type="km"
                    percentage={percentageToGoal()} 
                    colour="hsl(224, 50%, 40%)" 
                    steps={stepData.distanceDone} 
                    goal={stepData.routeDistance}/>
                </IonRow>
              </IonCol>
            </IonRow>
            <IonRow>
              { checkDatePast() === 'Aktiv' ? 
              <IonCard 
                className=" m-2 p-2 fullWidth">
                { myStats.enabled || isPlatform('iphone') ? 
                <>
                  <IonCardHeader className="p-2" color="light">
                    <IonCardTitle mode="md"  color="darkblue">
                      {api.tr('personal_activity')}
                    </IonCardTitle>
                  </IonCardHeader>
                  <IonCardContent>
                    <IonItem>
                      <IonLabel color="darkblue">
                        <b>{api.tr('daily_step_average')}</b> 
                      </IonLabel>
                      <IonText slot="end">{averageStepsDay().toFixed(0)} steg</IonText>
                    </IonItem>
                    <IonItem>
                      <IonLabel color="darkblue">
                        <b>{api.tr('distance_left')}</b>
                      </IonLabel>
                      <IonText slot="end">{((stepData.routeDistance - stepData.distanceDone) / 1000).toFixed(0)}  km</IonText>
                    </IonItem>
                    <IonRow className="mt-2 p-2">
                      <p>{api.tr('steps_done')} {((stepData.distanceDone / stepData.routeDistance) * 100).toFixed(1) } {api.tr('steps_percentage')}</p>
                    </IonRow>
                    <IonButton 
                      size="small" 
                      className="mt-2" 
                      onClick={() => goToPage('/walk/stepcounter')}>{api.tr('more_stats')}</IonButton>
                  </IonCardContent>
                </>
                : 
                <IonCardHeader className="flex justify-between items-center">
                  <IonCardTitle mode="md" >
                    <h2>{api.tr('activate_steps')}</h2>
                  </IonCardTitle>
                  <IonButton onClick={() => openSettings()}>
                    <IonIcon icon={arrowForward}/>
                  </IonButton>
                </IonCardHeader>
                }
              </IonCard>
              : null }
            </IonRow>
            <IonCard className="m-2">
              <IonCardHeader className="p-2" color="light">
                <IonCardTitle mode="md" >
                  Information
                </IonCardTitle>
                <IonCardSubtitle mode="md" >{api.tr('details')}</IonCardSubtitle>
              </IonCardHeader>
              <IonCardContent>
                <IonList>
                  <IonItem>
                    <IonIcon icon={people} slot="start" color="darkblue"/>
                    <IonLabel className="ml-2"><b className="color_blue">{api.tr('active_persons')}</b></IonLabel>
                    <IonText slot="end">
                      { stepData.persons.length }
                    </IonText>
                  </IonItem>
                  <IonItem>
                    <IonIcon icon={trophy} slot="start" color="darkblue"/>
                    <IonLabel className="ml-2"><b className="color_blue">{api.tr('goal')}</b></IonLabel>
                    <IonText slot="end">
                      { (stepData.routeDistance / 1000).toFixed(0) } km
                    </IonText>
                  </IonItem>
                  <IonItem>
                    <IonIcon icon={map} slot="start" color="darkblue"/>
                    <IonLabel className="ml-2"><b className="color_blue">{api.tr('route')}</b></IonLabel>
                    <IonText slot="end">
                      { stepData.routeName }
                    </IonText>
                  </IonItem>
                </IonList>
              </IonCardContent>
            </IonCard>
          </IonGrid>
          : 
          <IonGrid>
            <IonList className="">
              <IonListHeader>
                <IonItemDivider className="p-2" color="darkblue">
                  <IonLabel>Scoreboard</IonLabel>
                  <IonLabel slot="end">{api.tr('steps')}</IonLabel>
                </IonItemDivider>
              </IonListHeader>
              { score && score.map((person: any, key: any) => <IonItem 
                key={key + person.id + 'score'} 
                lines="full" 
                color={person.id === myself.id ? 'light': undefined}>
                  <IonAvatar slot="start">
                    <img src={person.id === myself.id ? myself.picture : "/assets/images/profile.png"} alt="" />
                  </IonAvatar>
                  <IonLabel className="ml-2">{person.id === myself.id ? myself.firstName : null}</IonLabel>
                  <IonText slot="end">{person.stepsTotal}</IonText>
              </IonItem>) }
            </IonList>
          </IonGrid>
          }
        </IonGrid>  
        }
        <SafetyPadding/>
      </IonContent> 
        : 
      <IonContent>
        <IonGrid>
          <IonRow className="flex justify-center items-center p-2 mt-4">
            <IonSpinner/>
          </IonRow>
        </IonGrid>
        <SafetyPadding/>
      </IonContent>
      }
    </IonPage>
  )
}
export default ChallengeStatistic